import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import Association from '../../../../assets/icons/Association';
import IconGroups from '../../../../assets/icons/IconGroups';
import * as css from '../subscriptionCard/SubscriptionCard.css';
import {SubscriptionPlan} from '../../../../redux/subscription/subscription.type';
import ModeBtn from '../../../../component/modeBtn/ModeBtn';
import SubscriptionOptions from '../subscriptionRow/SubscriptionOptions';

interface PopupActionsProps {
    plan: SubscriptionPlan;
    onEdit: () => void;
    onAssociateEvents: () => void;
    onAssociateGroups: () => void;
}
function HeaderActions({plan, status, handleActive}: {plan: SubscriptionPlan; status: boolean; handleActive: () => void}) {
    return (
        <>
            <ModeBtn 
                status={status}
                className={'small'}
                click={handleActive}
                dataCyName={`subscription-${plan.planTid}`} 
                requestStatus={undefined} 
                dataTitle={undefined} 
                text={undefined}
            />
            <SubscriptionOptions plan={plan} />
        </>
    );
}

function BottomActions({plan, onEdit, onAssociateEvents, onAssociateGroups}: PopupActionsProps) {
    const {t} = useTranslation('subscriptions');
    return (
        <>
            <Button
                data-cy="subscription-details-edit-btn"
                variant="neutral"
                size="category"
                onClick={onEdit}
            >
                {t('editDetails')}
            </Button>
            <css.wrap>
                <Button
                    data-cy="subscription-details-associate-groups-btn"
                    variant="brand"
                    size="category"
                    iconStart={<IconGroups />}
                    disabled={true}
                    onClick={onAssociateGroups}
                >
                    {plan.groupsCount > 0 ? <css.counts margin={'0px'}>{plan.groupsCount}</css.counts> : ''}
                </Button>
                <Button
                    data-cy="subscription-details-associate-events-btn"
                    variant="brand"
                    size="category"
                    iconStart={<Association />}
                    onClick={onAssociateEvents}
                >
                    {t('associateEvents')}
                    {plan.eventsCount > 0 && <css.counts>{plan.eventsCount}</css.counts>}
                </Button>
            </css.wrap>
        </>
    );
}

export {HeaderActions, BottomActions};

